import { render, staticRenderFns } from "./MiniProductDetailPageScreen.vue?vue&type=template&id=6c441fec&scoped=true&"
import script from "./MiniProductDetailPageScreen.vue?vue&type=script&lang=js&"
export * from "./MiniProductDetailPageScreen.vue?vue&type=script&lang=js&"
import style0 from "./MiniProductDetailPageScreen.vue?vue&type=style&index=0&id=6c441fec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c441fec",
  null
  
)

export default component.exports